import { createSlice } from '@reduxjs/toolkit';
import { COUNTRIES } from 'src/app/leads/leads.constant';

export const LEAD_PROPERTY_INFORMATION = {
  propertyName: '',
  address: '',
  country: COUNTRIES[0],
  state: {},
  city: '',
  zipCode: '',
  county: '',
  placeId: '',
  tenancy: '',
  buildingStatus: '',
  primaryVertical: '',
  landArea: '',
  rba: '',
  amenities: '',
  numberOfParkingSpaces: '',
  numberOfLoadingDocks: '',
};

export const LEAD_OWNER_INFORMATION = {
  name: '',
  contactFirstName: '',
  contactLastName: '',
  email: '',
  emailDomain: '',
  phoneNumber: '',
  cellNumber: '',
  address: '',
  ownerAffiliation: '',
  websiteUrl: '',
  country: COUNTRIES[0],
  state: {},
  city: '',
  zipCode: '',
  placeId: '',
};

export const CONTACT = {
  firstName: '',
  lastName: '',
  title: '',
  email: '',
  phoneNumber: '',
  cellNumber: '',
  ownerAffiliation: '',
  address: '',
  country: COUNTRIES[0],
  state: {},
  city: '',
  zipCode: '',
  placeId: '',
};

export const LEAD_COMPANY_INFORMATION = {
  name: '',
  secondaryVertical: '',
  propertyAffiliation: [],
  numberOfEmployees: '',
  floorNumber: '',
  naics: '',
  squareFootage: '',
  phoneNumber: '',
  emailDomain: '',
  revenue: '',
  websiteUrl: '',
  contacts: [{ ...CONTACT }],
};

const initialErrors = {
  propertyInformation: {},
  owner: {},
  companies: [],
};

const initialState = {
  propertyInformation: { ...LEAD_PROPERTY_INFORMATION },
  owner: { ...LEAD_OWNER_INFORMATION },
  companies: [{ ...LEAD_COMPANY_INFORMATION }],
  errors: { ...initialErrors },
};

const createLead = createSlice({
  name: 'lead',
  initialState,
  reducers: {
    updateField: (state, action) => {
      const { section, field, value } = action.payload;
      if (Array.isArray(state[section])) {
        state[section][action.payload.index][field] = value;
      } else {
        state[section][field] = value;
      }
    },
    updateSection: (state, action) => {
      const { section, data, index } = action.payload;
      if (index > -1) {
        state[section][index] = data;
      } else {
        state[section] = data;
      }
    },
    updateContacts: (state, action) => {
      const { data, index, companyIndex } = action.payload;
      if (companyIndex > -1 && index > -1) {
        state.companies[companyIndex].contacts[index] = data;
      } else if (companyIndex > -1) {
        state.companies[companyIndex].contacts = data;
      }
    },
    updateContactsError: (state, action) => {
      const { index, companyIndex, errors } = action.payload;
      if (companyIndex > -1 && index > -1) {
        if (state?.errors?.companies?.[companyIndex]?.contacts) {
          state.errors.companies[companyIndex].contacts[index] = errors;
        } else {
          state.errors.companies[companyIndex] = {
            ...state?.errors?.companies?.[companyIndex],
            contacts: [],
          };
          state.errors.companies[companyIndex].contacts[index] = errors;
        }
      }
    },
    updateForm: (state, action) => {
      return { ...state, ...initialState, ...action.payload };
    },
    resetForm: () => ({ ...initialState }),
    updateErrors: (state, action) => {
      const { section, errors, index } = action.payload;
      if (!section) {
        state['errors'] = { ...initialErrors, ...errors };
      } else if (index > -1) {
        if (!state['errors'][section]) state['errors'][section] = [];
        state['errors'][section][index] = errors;
      } else {
        state['errors'][section] = errors;
      }
    },
    deleteContact: (state, action) => {
      const { index, companyIndex } = action.payload;
      if (companyIndex > -1 && index > -1) {
        if (state.companies?.[companyIndex]?.contacts?.[index]?.id) {
          state.companies[companyIndex].contacts[index].isDeleted = true;
        } else {
          state.companies[companyIndex].contacts.splice(index, 1);
        }
      }
    },
    deleteCompany: (state, action) => {
      const { index } = action.payload;
      if (index > -1) {
        if (state.companies?.[index]?.id) {
          state.companies[index].isDeleted = true;
        } else {
          state.companies.splice(index, 1);
        }
      }
    },
    addCompany: (state) => {
      state.companies.push({ ...LEAD_COMPANY_INFORMATION });
    },
    addContact: (state, action) => {
      const { index } = action.payload;
      if (index > -1) {
        state.companies[index].contacts.push({ ...CONTACT });
      }
    },
  },
});

export const {
  updateField,
  updateSection,
  resetForm,
  updateErrors,
  updateContacts,
  updateContactsError,
  updateForm,
  addCompany,
  addContact,
  deleteCompany,
  deleteContact,
} = createLead.actions;
export default createLead.reducer;
